import { render, staticRenderFns } from "./AdminRoom.vue?vue&type=template&id=ce147a08&scoped=true&"
import script from "./AdminRoom.vue?vue&type=script&lang=js&"
export * from "./AdminRoom.vue?vue&type=script&lang=js&"
import style0 from "./AdminRoom.vue?vue&type=style&index=0&id=ce147a08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce147a08",
  null
  
)

export default component.exports